import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'

import Category from '../pages/Category'
import Product from '../pages/Product'
import CheckCustomer from '../pages/CheckCustomer'
import Checkout from '../pages/Checkout'
import CheckoutSuccess from "../pages/CheckoutSuccess";
import Cart from '../pages/Cart'
import PaymentFeedback from '../pages/PaymentFeedback'
import ScanProduct from '../pages/ScanProduct'
import CookiePolicy from '../pages/CookiePolicy'
import GiftProduct from '../pages/GiftProduct'

Vue.use(VueMeta);
Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        { path: '/', component: Category, name: 'Homepage' },
        { path: '/category/:alias', component: Category },
        { path: '/product/:alias', component: Product },
        { path: '/gift-product/:alias', component: GiftProduct },
        { path: '/scan/product', component: ScanProduct},
        { path: '/check-customer', component: CheckCustomer, name: 'CheckingCustomer' },
        { path: '/cart', component: Cart, name: 'Cart' },
        { path: '/checkout', component: Checkout, name: 'Checkout' },
        { path: '/checkout/success', component: CheckoutSuccess },
        { path: '/payment/feedback/:eshopId/', component: PaymentFeedback},
        { path: '/privacy', component: CookiePolicy}
    ],
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})
